<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185 185" id="target">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <circle id="Ellipse_3-2" data-name="Ellipse 3-2" class="cls-12" cx="92.5" cy="92.5"
                        r="92.5"/>
                <g xmlns="http://www.w3.org/2000/svg" id="Group_1942" data-name="Group 1942" transform="translate(37.463 37.351)" class="targetTarget">
                    <path id="Path_510" data-name="Path 510" d="M3699.581,1079.713a17.83,17.83,0,1,1,12.487-30.557,1.766,1.766,0,0,1-2.475,2.521,14.194,14.194,0,1,0,3.631,5.9,1.766,1.766,0,0,1,3.37-1.059,17.852,17.852,0,0,1-17.013,23.2Z" transform="translate(-3655.342 -995.819)" fill="#fff"/>
                    <path id="Path_511" data-name="Path 511" d="M3591.777,985.512a31.462,31.462,0,1,1,22.115-53.838,1.766,1.766,0,1,1-2.483,2.512,27.852,27.852,0,1,0,4.923,6.543,1.766,1.766,0,1,1,3.1-1.687,31.466,31.466,0,0,1-27.657,46.47Z" transform="translate(-3547.539 -887.988)" fill="#fff"/>
                    <path id="Path_512" data-name="Path 512" d="M3490.715,897.23a44.242,44.242,0,1,1,31.176-75.638,1.766,1.766,0,0,1-2.489,2.507,40.671,40.671,0,1,0,5,6.026,1.766,1.766,0,1,1,2.921-1.987,44.229,44.229,0,0,1-36.61,69.091Z" transform="translate(-3446.476 -786.924)" fill="#fff"/>
                    <circle id="Ellipse_6" data-name="Ellipse 6" cx="4.735" cy="4.735" r="4.735" transform="translate(39.386 61.227)" fill="#fff"/>
                </g>
                <g xmlns="http://www.w3.org/2000/svg" class="targetArrow" id="Group_1941" data-name="Group 1941" style="transform: translate(80.354px, 37px);">
                    <path id="Path_513" data-name="Path 513" d="M3825.581,917.547a1.766,1.766,0,0,1-1.25-3.015l34.423-34.421a1.766,1.766,0,0,1,2.5,2.5l-34.423,34.421A1.761,1.761,0,0,1,3825.581,917.547Z" transform="translate(-3823.815 -849.819)" fill="#fff"/>
                    <path id="Path_514" data-name="Path 514" d="M4253.354,778.176a1.766,1.766,0,0,1-1.249-3.015l16.178-16.178a1.766,1.766,0,0,1,2.5,2.5L4254.6,777.659A1.76,1.76,0,0,1,4253.354,778.176Z" transform="translate(-4203.572 -742.287)" fill="#fff"/>
                    <path id="Path_515" data-name="Path 515" d="M4289.982,741.573a1.767,1.767,0,0,1-.331-.031l-13.593-2.582a1.766,1.766,0,1,1,.66-3.471l13.592,2.582a1.766,1.766,0,0,1-.328,3.5Z" transform="translate(-4224.021 -721.862)" fill="#fff"/>
                    <path id="Path_516" data-name="Path 516" d="M4255.935,631.46a1.767,1.767,0,0,1-1.734-1.437l-2.586-13.6a1.767,1.767,0,0,1,3.472-.66l2.586,13.6a1.768,1.768,0,0,1-1.737,2.1Z" transform="translate(-4203.569 -614.331)" fill="#fff"/>
                    <path id="Path_517" data-name="Path 517" d="M4109.22,634.045a1.766,1.766,0,0,1-1.249-3.015l16.178-16.178a1.766,1.766,0,0,1,2.5,2.5l-16.179,16.178A1.761,1.761,0,0,1,4109.22,634.045Z" transform="translate(-4075.617 -614.334)" fill="#fff"/>
                    <path id="Path_518" data-name="Path 518" d="M4125.4,778.174a1.769,1.769,0,0,1-.332-.031l-14.773-2.807-2.811-14.777a1.766,1.766,0,1,1,3.47-.66l2.362,12.415,12.41,2.358a1.766,1.766,0,0,1-.327,3.5Z" transform="translate(-4075.614 -742.285)" fill="#fff"/>
                </g>
            </g>
        </g>
    </svg>


</template>

<script>
export default {
    name: "svg-opp"
}
</script>

<style scoped lang="scss">
.cls-12 {
    fill: #802669;
}

.cls-2 {
    fill: #fff;
}
svg {
    transition: 200ms all ease-in-out;
    &:hover {
        transform: scale(1.1);
    }
}
</style>
